module.exports = "/images/european_union.svg?1e235599aa2990640426086f1b4c8dd4";